import { ApiResponse } from '../types'
import { log } from './helpers'
import {captureMessage} from "@sentry/react"
export class API {
	#token: string | undefined
	#root: string

	constructor(root: string, token?: string | undefined) {
		this.#token = token
		this.#root = root
	}

	getRoot(): string {
		return this.#root
	}
	getToken(): string | undefined {
		return this.#token
	}
	setToken(token: string | undefined) {
		this.#token = token
	}

	async #wrapper<T>(method: string, path: string, data: object | null = null): ApiResponse<T> {
		const url = `${this.#root}${path}`

		const headers: HeadersInit = {
			'Content-Type': 'application/json',
			rmbcookie: this.rmbGetCookie('rmbid'),
			...(this.#token && { Authorization: `Bearer ${this.#token}` }),
		}

		const options: RequestInit = {
			method,
			headers,
			body: data ? JSON.stringify(data) : undefined,
		}

		try {

			const result = await fetch(url, options);

			if (!result.ok && result.status === 500) {
				// manage status 500 error separately
				captureMessage(`Response status 500, url: ${url} | options: ${JSON.stringify(options)} | result: ${result.text()}`)
				return { result: 'nok', message: 'Unexpected error' }	
			}
			
			if (result.status === 0) {
				// manage cors er error separately
				captureMessage(`CORS, url: ${url} | options: ${JSON.stringify(options)} | result: ${result.text()}`)
				return {
					result: 'nok',
					message: 'CORS error: The server did not allow the request.',
				};
			}

			const contentType = result.headers.get("content-type");
			if (contentType && contentType.includes("application/json")) {
				return await result.json();
			} else {
				const text = await result.text()
				return { result: 'nok', message: `content-type ${contentType} is not application/json: ${text}` }
			}
		} catch(error: any) {

			log(error.stack)
			return { result: 'nok', message: 'Unexpected error' }
		}
	}

	protected rmbGetCookie = (name: string) => {
		let value = `; ${document.cookie}`
		let parts = value.split(`; ${name}=`)
		if (parts.length === 2) return parts.pop()?.split(';').shift() ?? ''
		return ''
	}
	protected async get<T>(path: string) {
		return this.#wrapper<T>('GET', path)
	}

	protected async post<T>(path: string, data: object) {
		return this.#wrapper<T>('POST', path, data)
	}

	protected async put(path: string, data: object): ApiResponse<unknown> {
		return this.#wrapper('PUT', path, data)
	}

	protected async delete(path: string): ApiResponse<unknown> {
		return this.#wrapper('DELETE', path)
	}

	protected async fake(data: object, ms?: number | undefined): ApiResponse<unknown> {
		const error = false
		return new Promise((resolve) => setTimeout(resolve, ms ?? 1000)).then(() => ({
			result: error ? 'nok' : 'ok',
			message: error ? 'error' : 'success',
			data,
		}))
	}
}
